import styled, { keyframes } from 'styled-components';
import { device } from '../../../breakpoints';
import PlayText from '../../../typography/PlayText/PlayText';
import { VisuallyHidden } from '../../../utils.styles';

export const EditModeWrapper = styled.div`
    text-align: center;
    position: absolute;
    z-index: 888;
    display: block;
    width: 150px;
    height: auto;
    left: 50%;
    transform: translate(-50%, -22%);
    top: 45%;

    @media ${device.GteMedium} {
        width: 200px;
    }
`;

export const OverlayContent = styled(PlayText)`
    margin-top: 5px;
    margin-bottom: 5px;

    @media ${device.GteMedium} {
        margin-top: 11px;
        margin-bottom: 15px;
    }
`;

const linkFadeIn = keyframes`
    0% {
        opacity: 0;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

export const OverlayLink = styled(PlayText)`
    animation: ${linkFadeIn} 400ms 1;
`;

export const HiddenTitle = styled.span`
    ${VisuallyHidden}
`;
